/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isObject from 'lodash/isObject';

/**
 * Komunikátor analytických dat pro Ki-Wi Server.
 */
class CommunicatorAnalytics {
  /**
   * Zpracuje periodu zasílání analytických dat.
   * @param {Object} json Část odpovědi na obsah zařízení s nastavením analýzy.
   * @returns {number|null} Doba, kterou má trvat analytický cyklus. [ms]
   */
  static parse(json) {
    let result;
    if (isObject(json) && json.type === 'server' && json.frequency > 0) {
      result = json.frequency * 1000;
    } else {
      result = null;
    }
    return result;
  }
}

export default CommunicatorAnalytics;
